function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { BreadcrumbsPseudo as BaseBreadcrumbsPseudo } from "sprout-ui-dom/dist/Breadcrumbs";
import memoDownshiftProps from "sprout-ui-dom/dist/memoDownshiftProps";
import { TopicSelectable, SelectablesGroup } from "sprout-ui-dom/dist/Selectables";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import { GroupType } from "sprout-hooks/dist/useProcessTopicsToGroups";
import { InboxOutlined, PersonOutlined, TaskAltOutlined } from "sprout-ui-icons";
import { MoveItemsDialogView } from "./MoveItemsDialogContext";
const MemoTopicSelectable = memoDownshiftProps(TopicSelectable);
const BreadcrumbsPseudo = styled(BaseBreadcrumbsPseudo)`
  color: ${themeGet("colors.white.70")};
  margin-bottom: 2px;
`;
function getSpecialTopicIcon(special) {
    if (special === "MY_TASKS") return TaskAltOutlined;
    else if (special === "INBOX") return InboxOutlined;
    else if (special === "PROFILE") return PersonOutlined;
    else return undefined;
}
const MoveItemsDialogGroups = (props)=>{
    const { groups , getItemProps , inputValueRef , hideDepth , view , initialCurrentTopicId ,  } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: groups.map(({ items , type , heading  })=>{
            return /*#__PURE__*/ _jsx(SelectablesGroup, {
                heading: heading,
                children: type === GroupType.CURRENT ? items.map((item)=>{
                    const { topic  } = item;
                    const { linkImages , title  } = topic;
                    const image = linkImages && linkImages[0] || undefined;
                    const depth = [
                        MoveItemsDialogView.CLEAN,
                        MoveItemsDialogView.SCOPED, 
                    ].includes(view) && hideDepth ? 0 : item.depth;
                    const disabled = view === MoveItemsDialogView.ADD ? false : topic.id === initialCurrentTopicId;
                    return /*#__PURE__*/ _jsx(MemoTopicSelectable, _objectSpread({
                        title: title || "No title",
                        depth: depth,
                        disabled: disabled,
                        image: image,
                        save: !disabled
                    }, !disabled && getItemProps({
                        item: {
                            type,
                            topicId: topic.id,
                            inputValue: inputValueRef.current
                        }
                    })), topic.nodeId);
                }) : type === GroupType.RECENT ? items.map((topic)=>{
                    const { linkImages , title , rootTopicOrSelf , parentTopic , special ,  } = topic;
                    if (special) return /*#__PURE__*/ _jsx(MemoTopicSelectable, _objectSpread({
                        title: title,
                        save: true,
                        icon: getSpecialTopicIcon(special)
                    }, getItemProps({
                        item: {
                            type: GroupType.SPECIAL_TREE,
                            special
                        }
                    })), special);
                    const { owner  } = rootTopicOrSelf || {};
                    const image = linkImages && linkImages[0] || undefined;
                    const disabled = view === MoveItemsDialogView.ADD ? false : topic.id === initialCurrentTopicId;
                    return /*#__PURE__*/ _jsx(MemoTopicSelectable, _objectSpread({
                        breadcrumbsPseudo: rootTopicOrSelf && owner && parentTopic ? /*#__PURE__*/ _jsx(BreadcrumbsPseudo, {
                            showTeam: true,
                            owner: owner,
                            parentTopic: parentTopic,
                            rootTopic: rootTopicOrSelf,
                            renderAsLink: false
                        }) : undefined,
                        title: title || "No title",
                        disabled: disabled,
                        image: image,
                        save: !disabled
                    }, !disabled && getItemProps({
                        item: {
                            type,
                            topicId: topic.id
                        }
                    })), topic.nodeId);
                }) : type === GroupType.SPECIAL_TREE ? items.map((item)=>{
                    return /*#__PURE__*/ _jsx(MemoTopicSelectable, _objectSpread({
                        title: item.title,
                        save: true,
                        icon: getSpecialTopicIcon(item.special)
                    }, getItemProps({
                        item: {
                            type: GroupType.SPECIAL_TREE,
                            special: item.special
                        }
                    })), item.special);
                }) : items.map((topic)=>{
                    const { linkImages , isRootTopic , title , directSubtopicCount , teamVisible , contributorCount ,  } = topic;
                    const image = linkImages && linkImages[0] || undefined;
                    const showArrow = !!(isRootTopic && directSubtopicCount);
                    const showLock = !topic.public && !teamVisible;
                    const showContributors = contributorCount ? contributorCount > 1 : false;
                    const disabled = view === MoveItemsDialogView.ADD ? false : topic.id === initialCurrentTopicId;
                    const save = !showArrow && !disabled;
                    return /*#__PURE__*/ _jsx(MemoTopicSelectable, _objectSpread({
                        title: title || "No title",
                        disabled: disabled,
                        image: image,
                        lock: showLock,
                        arrow: showArrow,
                        contributors: showContributors,
                        save: save
                    }, !disabled && getItemProps({
                        item: {
                            type,
                            topicId: topic.id,
                            hasChildren: isRootTopic && directSubtopicCount ? directSubtopicCount > 0 : false
                        }
                    })), topic.nodeId);
                })
            }, heading);
        })
    });
};
export default MoveItemsDialogGroups;
